type SkeletonVariant = 'rectangular' | 'circular';

interface ISkeletonLoader {
  width?: string | number;
  height?: string | number;
  variant?: SkeletonVariant;
  customClassName?: string;
}

export const SkeletonLoader = ({ width, height, variant = 'rectangular', customClassName = '' }: ISkeletonLoader) => {
  return (
    <div
      className={`fullSkeleton ${variant === 'circular' ? 'rounded-full' : ''} ${customClassName}`}
      style={{ width, height }}
    ></div>
  );
};
